import ProjectCreateModal from 'components/modals/ProjectCreateModal/ProjectCreateModal';
import useModal from './useModal';

const useProjectCreate = () => {
  const modal = useModal();

  const handleCreateClick = () => {
    modal.render({
      key: 'projectCreate',
      modal: <ProjectCreateModal />,
    });
  };

  return {
    onCreateClick: handleCreateClick,
  };
};

export default useProjectCreate;
